import { Controller } from '@hotwired/stimulus';
import tippy from 'tippy.js';

export default class extends Controller {
  static targets = ['trigger', 'content'];

  static values = { options: Object };

  connect() {
    this.initializeTippy();
  }

  initializeTippy() {
    tippy(this.triggerTarget, {
      content: this.contentTarget.innerHTML,
      allowHTML: true,
      placement: 'top',
      interactive: true,
      appendTo: document.body,
      ignoreAttributes: true,
      ...this.optionsValue,
    });
  }
}
